export type AppMode = 'gestor' | 'clientes'

export interface UrlLocationLike {
  hostname?: string
  pathname?: string
  search?: string
}

export function detectAppMode(loc: UrlLocationLike = typeof window !== 'undefined' ? window.location : {}): AppMode {
  const host = (loc.hostname || '').toLowerCase()
  const path = (loc.pathname || '').toLowerCase()
  const search = loc.search || ''

  // 1. Subdominio explícito: fuente de verdad definitiva
  if (host.startsWith('gestor') || host.includes('.gestor.')) {
    return 'gestor'
  }
  if (host.startsWith('clientes') || host.includes('.clientes.')) {
    return 'clientes'
  }

  // 2. Fallback solo para desarrollo local (localhost / 127.0.0.1)
  if (path === '/gestor' || path.startsWith('/gestor/') || path.startsWith('/gestor.')) {
    return 'gestor'
  }

  const params = new URLSearchParams(search)
  if (params.get('app') === 'gestor') {
    return 'gestor'
  }

  return 'clientes'
}
